import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function BuildingViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Building())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(BuildingViewModel, SearchPaging);
BuildingViewModel.prototype.PrimaryKey = "BuildingId";
BuildingViewModel.prototype.RefreshUrl = "Building/GetBuilding";
BuildingViewModel.prototype.SaveUrl = "Building/SaveBuilding";
BuildingViewModel.prototype.DeleteUrl = "Building/DeleteBuilding";
BuildingViewModel.prototype.IsInUseUrl = "Building/IsBuildingInUse";
BuildingViewModel.prototype.PermissionForward = "BuildingMoveForwardSearch";
BuildingViewModel.prototype.PermissionBackward = "BuildingMoveBackwardSearch";
BuildingViewModel.prototype.PermissionSave = "BuildingSave";
BuildingViewModel.prototype.PermissionRefresh = "BuildingRefresh";
BuildingViewModel.prototype.PermissionDelete = "BuildingDelete";
export default BuildingViewModel;